module.exports = __webpack_public_path__ + "img/advertisement_bg.c10cda64.png";